import { useContext } from 'react';
import { NavigationContext } from '@context/navigation_context';

export const useNavigationContext = () => useContext(NavigationContext);
